// utility fns

import { fitBounds } from 'google-map-react/utils'


// lines and arrows
export const color = 'red'
// export const color = '#0cf' // bluegreen
// export const color = '#bf3' // green
// export const color = 'blue'
export const opacity = 1.0
export const width = 1.5

// define an arrow svg shape
const base = 3
const height = 7
export const arrow = {
  path: `M 0,0 ${base},${height} -${base},${height} 0,0 z`, // 0,0 is the tip of the arrow
  fillColor: color,
  fillOpacity: opacity,
  strokeColor: color,
  strokeWeight: 1,
}


const mapOptions = {
  fullscreenControl: false,
  // zoomControl: true,
  // mapTypeControl: true,
  // scaleControl: true,
  // streetViewControl: true,
  // rotateControl: true,
  // // bw style --->
  // styles: [{ stylers: [{ 'saturation': -100 }, { 'gamma': 0.8 }, { 'lightness': 4 }, { 'visibility': 'on' }] }],
}
export const createMapOptions = (maps) => mapOptions


// eg 'n,e,s,w' -> {ne:{lat,lng},sw:{lat,lng}}
export function getBoundsFromString(boundsStr) {
  const arr = boundsStr.split(',').map(Number)
  const bounds = {
    ne: { lat: arr[0], lng: arr[1] },
    sw: { lat: arr[2], lng: arr[3] },
  }
  return bounds
}

export function getEdgesFromString(boundsStr) {
  const bounds = getBoundsFromString(boundsStr)
  const edges = { north: bounds.ne.lat, east: bounds.ne.lng, south: bounds.sw.lat, west: bounds.sw.lng }
  return edges
}

export function getCenterFromString(centerStr) {
  const arr = centerStr.split(',').map(Number)
  const center = { lat: arr[0], lng: arr[1] }
  return center
}

// get minmax extent of array of places
function getExtent(places) {
  let latmin = 400, latmax = -400, lngmin = 400, lngmax = -400
  for (let place of places) {
    if (place.bounds) {
      const { ne, sw } = place.bounds
      const n = ne.lat, e = ne.lng, s = sw.lat, w = sw.lng
      if (n > latmax) latmax = n
      if (s < latmin) latmin = s
      if (e > lngmax) lngmax = e
      if (w < lngmin) lngmin = w
    }
    if (place.center) {
      const { lat, lng } = place.center
      if (lat > latmax) latmax = lat
      if (lat < latmin) latmin = lat
      if (lng > lngmax) lngmax = lng
      if (lng < lngmin) lngmin = lng
    }
  }
  return [latmin, latmax, lngmin, lngmax]
}


// get center and zoom to fit all given places on map
export function getView(places, mapdiv, defaultView) {
  // console.log('getView', places, mapdiv, defaultView)
  let view = defaultView
  if (places.length > 0) {
    let [latmin, latmax, lngmin, lngmax] = getExtent(places)
    const [height, width] = [latmax - latmin, lngmax - lngmin]
    const epsilon = 0.00001 // degree
    const isPointlike = (Math.abs(height) < epsilon) || (Math.abs(width) < epsilon)
    if (isPointlike) {
      view = {}
      view.center = { lat: latmax, lng: lngmax }
      view.zoom = 14 // city level
    } else {
      // add padding in each direction
      const pct = 0.02
      const [heightpad, widthpad] = [height * pct, width * pct]
      latmax += heightpad
      latmin -= heightpad
      lngmax += widthpad
      lngmin -= widthpad
      // get corners and use googlemapreact's fn to get center and zoom
      const corners = { ne: { lat: latmax, lng: lngmax }, sw: { lat: latmin, lng: lngmin } }
      const divSize = { width: mapdiv.offsetWidth, height: mapdiv.offsetHeight } // pixels
      view = fitBounds(corners, divSize)
    }
  }
  return view
}
